export default function PrivacyPolicy() {
  return (
    <main className="min-h-screen bg-[#f0f4f7]">
      <section className="bg-[#2c2a4a] py-14 md:py-20">
        <div className="container-main text-center">
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-3">Privacy Policy</h1>
          <p className="text-white/70 text-base md:text-lg">Your privacy matters to us.</p>
        </div>
      </section>

      <section className="py-10 md:py-14">
        <div className="container-main max-w-3xl">
          <div className="space-y-8 text-[#4A4A4A] font-sans text-base leading-relaxed">
            <div>
              <h2 className="font-serif text-xl font-bold text-[#1A1A1A] mb-3">Information We Collect</h2>
              <p>
                When you visit SpinWorld.Us or make a purchase, we collect the information necessary to fulfill your order and provide a great shopping experience. This includes your name, email address, phone number, shipping address, billing information, and order details. We also collect non-personal information such as browser type, device information, and website usage patterns to improve our site.
              </p>
            </div>

            <div>
              <h2 className="font-serif text-xl font-bold text-[#1A1A1A] mb-3">How We Use Your Information</h2>
              <p>
                We use your personal information solely for order fulfillment, customer support, and occasional promotional emails about new products or sales. We do not sell, rent, or trade your personal information with third parties for marketing purposes. Your data is used to process payments, ship orders, respond to inquiries, and send order updates.
              </p>
            </div>

            <div>
              <h2 className="font-serif text-xl font-bold text-[#1A1A1A] mb-3">Data Security</h2>
              <p>
                We take reasonable precautions to protect your personal information. Our website uses secure HTTPS encryption, and payment processing is handled by trusted third-party providers with industry-standard security measures. We store order data in a secure database and limit access to authorized personnel only.
              </p>
            </div>

            <div>
              <h2 className="font-serif text-xl font-bold text-[#1A1A1A] mb-3">Cookies and Tracking</h2>
              <p>
                Our website uses cookies to enhance your browsing experience, remember your preferences, and analyze site traffic. You can disable cookies in your browser settings, though this may affect certain features of the site such as cart persistence.
              </p>
            </div>

            <div>
              <h2 className="font-serif text-xl font-bold text-[#1A1A1A] mb-3">Third-Party Services</h2>
              <p>
                We use trusted third-party services for payment processing, shipping logistics, and website analytics. These providers have access to limited information necessary to perform their services and are contractually obligated to protect your data. We do not share your information with social media platforms or advertising networks.
              </p>
            </div>

            <div>
              <h2 className="font-serif text-xl font-bold text-[#1A1A1A] mb-3">Your Rights</h2>
              <p>
                You have the right to access, correct, or delete your personal information at any time. To request changes or deletion of your data, please contact us at <a href="mailto:Spinworld@myyahoo.com" className="text-[#4f528d] hover:underline">Spinworld@myyahoo.com</a>. We will respond to all requests within 30 days.
              </p>
            </div>

            <div>
              <h2 className="font-serif text-xl font-bold text-[#1A1A1A] mb-3">Policy Updates</h2>
              <p>
                We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date. We encourage you to review this policy periodically to stay informed about how we protect your information.
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}